import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../lib/tracking';
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_BASE, WHATSAPP_GENERIC_MESSAGE } from '../lib/constants';

export default function LeanHeaderCarp() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/90 backdrop-blur-xl border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" aria-label="Home Office Premium" className="flex items-center flex-shrink-0">
          <img
            src="/media/marca/d80a63e2-93d1-4226-9f6e-320a91838de0_horizontal-cinza.png"
            alt="Home Office Premium"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </Link>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href={`tel:${PHONE_TEL}`}
            onClick={() => trackEvent('phone_click')}
            className="hidden sm:inline-flex items-center gap-2 text-foreground-700 hover:text-foreground-950 text-[13px] font-medium transition-colors whitespace-nowrap cursor-pointer px-3 py-2 rounded-full hover:bg-background-100"
          >
            <i className="ri-phone-line text-base"></i>
            {PHONE_DISPLAY}
          </a>

          <a
            href={`${WHATSAPP_BASE}?text=${WHATSAPP_GENERIC_MESSAGE}`}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('whatsapp_carpete', { location: 'header' })}
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white text-[13px] font-semibold px-4 md:px-5 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-base"></i>
            <span className="hidden sm:inline">Falar com um especialista</span>
            <span className="sm:hidden">WhatsApp</span>
          </a>
        </div>
      </div>
    </header>
  );
}